import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {DataManagementService} from '../../services/data-management.service';
import {Constants} from '../../constants';
import {AuthenticationService} from '../../services/authentication.service';
import {AppSettings} from '../../../app-settings';
import { ToastrService } from 'ngx-toastr'; 
import { AccessService } from 'src/app/services/access.service';


@Component({
  selector: "app-results",
  templateUrl: "./results.component.html",
  styleUrls: ["./results.component.css"],
})
export class ResultsComponent implements OnInit {
  @ViewChild("addManuallyModal") addManuallyModal: TemplateRef<any>;
  @ViewChild("confirmationModal") confirmationModal: TemplateRef<any>; // Add this

  modalReference: NgbModalRef;
  universities = [];
  students = [];
  filteredStudents = [];
  allStudents = [];
  selectedUniversityId = "0";
  selectedStudentId = "0";
  selectedStudentIds: string[] = [];
  searchText: string = "";
  confirmationModalReference: NgbModalRef;

  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  biddingResults;
  rounds;
  data: object;
  selectUndefinedOptionValue = "0";
  downloadRoundWiseBiddingResults =
    AppSettings.DOWNLOAD_ROUND_WISE_BIDDING_RESULTS;
  outgoingRoundId = "0";
  token;
  errorMessage: string = undefined;
  isLoadingStudents: boolean = false;
  isLoadingUniversities: boolean = false;

  constructor(
    private modal: NgbModal,
    private accessService: AccessService,
    private dmService: DataManagementService,
    private authenticationService: AuthenticationService,
    private toastService: ToastrService
  ) {}

  getRoundsFilter(): void {
    this.dmService.getAll(Constants.ROUNDS_FILTER).subscribe(
      (response) => {
        if (response.status === "success") {
          this.rounds = response.data;
          if (this.rounds.length > 0) {
            this.outgoingRoundId = this.rounds[0].outgoing_round_id;
          }
        }
      },
      (error) => {
        console.log(error);
        this.errorMessage = "Server Error";
        // this.errorMessage = error;
      }
    );
  }

  getBiddingResults() {
    this.dmService
      .getOne(Constants.BIDDING_RESPONSE, this.outgoingRoundId)
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.biddingResults = response.data;
            if (this.biddingResults.length === 0) {
              this.errorMessage =
                "There is no data available for biddingResults.";
            } else {
              this.dtTrigger.next();
            }
          } else if (response.status === "fail") {
            this.errorMessage =
              "Failed to load Bidding results. Please contact support team";
          }
        },
        (error) => {
          console.log(error);
          this.errorMessage = "Server Error";
          // this.errorMessage = error;
        }
      );
  }

  addManually(): void {
    this.selectedUniversityId = "0";
    this.selectedStudentId = "0";
    this.filteredStudents = [];
    this.selectedStudentIds = [];
    this.searchText = "";

    this.getUniversitiesByRound(this.outgoingRoundId);
    this.getStudentsByAcademicYear(this.outgoingRoundId);

    this.modalReference = this.modal.open(this.addManuallyModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  getUniversitiesByRound(roundId: string): void {
    this.isLoadingUniversities = true;
    this.dmService
      .javaGetDataCallByParameter(
        Constants.UNIVERSITIES_BY_OUTGOING_ROUND_ID,
        roundId
      )
      .subscribe(
        (response) => {
          this.isLoadingUniversities = false;
          if (response.status === "success") {
            this.universities = response.data;
          } else {
            if (response.hasOwnProperty("message")) {
              this.toastService.warning(response.message, "Fail");
            } else {
              this.toastService.warning(
                "Something went wrong. please contact support team",
                "Fail"
              );
            }
            this.universities = [];
          }
        },
        (error) => {
          this.isLoadingUniversities = false;
          this.toastService.error("Server Error", "Error");
          this.universities = [];
        }
      );
  }

  clearSearch(): void {
    this.searchText = "";
    this.filterStudents();
  }

  getStudentsByAcademicYear(academicYearId: string): void {
    this.isLoadingStudents = true;
    this.dmService
      .javaGetDataCallByParameter(
        Constants.STUDENTS_BY_OUTGOING_ROUND_ID,
        academicYearId
      )
      .subscribe(
        (response) => {
          this.isLoadingStudents = false;
          if (response.status === "success") {
            this.allStudents = response.data;
            this.filteredStudents = response.data;
          } else {
            this.allStudents = [];
            this.filteredStudents = [];

            if (response.hasOwnProperty("message")) {
              this.toastService.warning(response.message, "Fail");
            } else {
              this.toastService.warning(
                "Something went wrong. please contact support team",
                "Fail"
              );
            }
          }
        },
        (error) => {
          this.isLoadingStudents = false;
          this.toastService.error("Server Error", "Error");
          this.filteredStudents = [];
          this.allStudents = [];

          console.error("Error loading students:", error);
        }
      );
  }

  addStudentToBiddingResults(): void {
    if (this.selectedStudentIds.length === 0) {
      this.toastService.warning(
        "Please select at least one student",
        "Warning"
      );
      return;
    }
    if (!this.selectedUniversityId || this.selectedUniversityId === "0") {
      this.toastService.warning("Please select a university", "Warning");
      return;
    }
    this.openConfirmationModal();

    // const payload = {
    //   outgoing_round_id: this.outgoingRoundId,
    //   student_ids: this.selectedStudentIds,
    //   university_id: this.selectedUniversityId,
    //   user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    // };

    // this.dmService
    //   .javaPostDataCall(payload, Constants.ADD_STUDENT_TO_BIDDING_RESULTS)
    //   .subscribe(
    //     (response) => {

    //          if (response.status === "success") {
    //       this.toastService.success(
    //           `${this.selectedStudentIds.length} student(s) added successfully`,
    //         "Success"
    //       );
    //       this.modalReference.close();
    //         this.getBiddingResults();
    //     } else if (response.status === "fail") {
    //       if (response.hasOwnProperty("message")) {
    //         this.toastService.warning(response.message, "Fail");
    //       } else {
    //         this.toastService.warning(
    //           "Something went wrong. please contact support team",
    //           "Fail"
    //         );
    //       }
    //     }

    //         // this.modalReference.close();
    //         // You can add a success message here if needed

    //     },
    //     (error) => {
    //       console.error("Error adding student:", error);
    //                 this.toastService.error("Server Error", "Error");

    //     }
    //   );
  }

  toggleStudentSelection(checked: boolean, studentId: string): void {
    if (checked) {
      if (!this.selectedStudentIds.includes(studentId)) {
        this.selectedStudentIds.push(studentId);
      }
    } else {
      const index = this.selectedStudentIds.indexOf(studentId);
      if (index > -1) {
        this.selectedStudentIds.splice(index, 1);
      }
    }
  }

  openConfirmationModal(): void {
    this.confirmationModalReference = this.modal.open(this.confirmationModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  isStudentSelected(studentId: string): boolean {
    return this.selectedStudentIds.includes(studentId);
  }
  selectAllStudents(): void {
    this.filteredStudents.forEach((student) => {
      if (!this.selectedStudentIds.includes(student.outgoing_student_id)) {
        this.selectedStudentIds.push(student.outgoing_student_id);
      }
    });
  }
  // selectAllStudents(): void {
  //   this.selectedStudentIds = this.filteredStudents.map(student => student.outgoing_student_id);
  // }

  clearAllStudents(): void {
    this.selectedStudentIds = [];
  }
  toggleSelectAll(checked: boolean): void {
    if (checked) {
      this.selectAllStudents();
    } else {
      const filteredStudentIds = this.filteredStudents.map(
        (s) => s.outgoing_student_id
      );
      this.selectedStudentIds = this.selectedStudentIds.filter(
        (id) => !filteredStudentIds.includes(id)
      );
    }
  }
  // toggleSelectAll(checked: boolean): void {
  //   if (checked) {
  //     this.selectAllStudents();
  //   } else {
  //     this.clearAllStudents();
  //   }
  // }
  isAllStudentsSelected(): boolean {
    return (
      this.filteredStudents.length > 0 &&
      this.selectedStudentIds.length === this.filteredStudents.length
    );
  }

  filterStudents(): void {
    if (!this.searchText) {
      this.filteredStudents = this.allStudents.slice();
      return;
    }

    const searchLower = this.searchText.toLowerCase();
    this.filteredStudents = this.allStudents.filter(
      (student) =>
        (student.name && student.name.toLowerCase().includes(searchLower)) ||
        (student.email && student.email.toLowerCase().includes(searchLower)) ||
        (student.registration_id &&
          student.registration_id.toLowerCase().includes(searchLower))
      // (student.programme_name && student.programme_name.toLowerCase().includes(searchLower)) ||
      // (student.gender_name && student.gender_name.toLowerCase().includes(searchLower)) ||
      // (student.batch && student.batch.toString().includes(searchLower))
    );
  }

  getSelectedStudentDetails(): any[] {
    return this.allStudents.filter((student) =>
      this.selectedStudentIds.includes(student.outgoing_student_id)
    );
  }

  getSelectedUniversityName(): string {
    const university = this.universities.find(
      (u) => u.university_id == this.selectedUniversityId
    );
    return university ? university.university_name : "Not selected";
  }

  confirmAddStudents(): void {
    if (this.confirmationModalReference) {
      this.confirmationModalReference.close();
    }

    const loadingToast = this.toastService.info(
      "Adding students...",
      "Please wait",
      {
        disableTimeOut: true,
        tapToDismiss: false,
      }
    );

    const payload = {
      outgoing_round_id: this.outgoingRoundId,
      student_ids: this.selectedStudentIds,
      university_id: this.selectedUniversityId,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };

    this.dmService
      .javaPostDataCall(payload, Constants.ADD_STUDENT_TO_BIDDING_RESULTS)
      .subscribe(
        (response) => {
          this.toastService.clear(loadingToast.toastId);

          if (response.status === "success") {
          
            this.toastService.success(
              `${this.selectedStudentIds.length} student(s) added successfully`,
              "Success"
            );

            this.getBiddingResults();
            if (this.modalReference) this.modalReference.close();
            this.selectedStudentIds = [];
            this.selectedUniversityId = "0";
          } else if (response.status === "fail") {

              if (response.data && response.data.alreadyAllottedStudents && response.data.alreadyAllottedStudents.length > 0) {
              const alreadyAllottedIds = response.data.alreadyAllottedStudents;
              const alreadyAllottedStudents = this.allStudents.filter((s) =>
                alreadyAllottedIds.includes(parseInt(s.outgoing_student_id))
              );
            
              if (alreadyAllottedStudents.length > 0) {
                const names = alreadyAllottedStudents.map((s) => s.name).join(", ");
                this.toastService.warning(
                  `Cannot add students. ${alreadyAllottedStudents.length} student(s) are already allotted: ${names}`,
                  "Already Allotted"
                );
              } else {
                // Fallback if student names not found
                this.toastService.warning(
                  `Cannot add students. ${alreadyAllottedIds.length} student(s) are already allotted (IDs: ${alreadyAllottedIds.join(', ')})`,
                  "Already Allotted"
                );
              }
            } else if (response.hasOwnProperty("message")) {
              this.toastService.warning(response.message, "Failed");
            }  else {
              this.toastService.warning(
                "Something went wrong. Please contact support team",
                "Failed"
              );
            }
          }
        },
        (error) => {
          this.toastService.clear(loadingToast.toastId);
          console.error("Error adding student:", error);
          this.toastService.error(
            "Server error occurred while adding students",
            "Error"
          );
        }
      );
  }

  getSelectedRoundDisplayName(): string {
    if (!this.outgoingRoundId || this.outgoingRoundId === this.selectUndefinedOptionValue) {
        return 'No Round Selected';
    }
      const selectedRound = this.rounds.find(r => r.outgoing_round_id == this.outgoingRoundId);
     if (selectedRound) {
        const termName = selectedRound.outgoing_term_name || 'Unknown Term';
        const roundName = selectedRound.outgoing_round_name || 'Unknown Round';
        return `${termName} - ${roundName}`;
    }
    
    return `Round ID: ${this.outgoingRoundId}`;
}

  canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

  ngOnInit() {
    this.getBiddingResults();
    this.getRoundsFilter();
    this.token = "?token=" + this.authenticationService.getToken();
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false,
    };
  }
}
